import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CompanyPageStepDetailsComponent } from './company-page-step-details.component';
import { VoiceInputModule } from 'src/app/shared/ai-assistant/voice-input/voice-input.module';
import { FormalizeCommentModule } from 'src/app/shared/ai-assistant/formalize-comment/formalize-comment.module';

@NgModule({
  declarations: [CompanyPageStepDetailsComponent],
  imports: [CommonModule, FormsModule, VoiceInputModule, FormalizeCommentModule],
  exports: [CompanyPageStepDetailsComponent],
  entryComponents: [CompanyPageStepDetailsComponent]
})
export class CompanyPageStepDetailsModule { }
